<template>
  <div class="material-table">
    <div class="material-table__actions">
      <a-space>
        <a-input-search
          v-model:value="keyword"
          enter-button
          class="w300"
          placeholder="请输入材料名称关键字"
          @search="search"
        ></a-input-search>
        <LibraryForm
          v-perm="'/material/library/create'"
          :isEdit="false"
          @refresh="search"
        >
        添加新材料
        </LibraryForm>
        <a-button type="primary" @click="add">加入待选 >></a-button>
      </a-space>
    </div>
    <table-wrapper
      :loading="loading"
      :dataSource="data"
      :pagination="pagination"
      @onSelectionChange="onSelectionChange"
      @onTableChange="onTableChange"
      :columns="columns"
      :tableHeight="tableHeight"
      :showFullJump="false"
    >
      <template #bizNo="{ record }">
        <!-- <router-link :to="`/material/library/detail/${record.id}`">
         
        </router-link> -->
        {{ record.bizNo }}
      </template>
    </table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, PropType ,Ref} from "vue";
import { LibraryService } from "@/views/material/library/library.service";
import { LibraryPageReq, LibraryListRecord } from "@/views/material/library/library.interface";
import { columns } from "./constant";
import {useRouter} from "vue-router"
import { computed } from "@vue/reactivity";
import LibraryForm from "@/views/material/library/list2/library-from-btn/index.vue";
export default defineComponent({
  components: {
    LibraryForm,
  },
  name: "MaterialTable",
  props: {
    value: {
      type: Array as PropType<LibraryListRecord[]>,
      default: [],
    },
    height:{
      type:Number,
      default:0
    },
    materialCategoryId: {
      type: String,
      default: "",
    },
    hideColumn: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
  },
  emits: ["update:value",'close'],
  setup(props, { emit }) {
    const router = useRouter()
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: LibraryListRecord[];
      selectedList: any[];
      columns: Ref<any[]>;
      tableHeight:Ref<number>;
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns:computed(()=>{
        return columns.filter((item) => !props.hideColumn.includes(item.key));
      }),
      tableHeight:computed(()=>{
        return props.height-122-30;
      })
    });

    const queryReq = new LibraryPageReq({});
    queryReq.merge({ materialCategoryId: "", enable: true });
    const queryRef = reactive(queryReq);
    const { data, loading, run, refresh, pagination } = LibraryService.usePageApi();

    const search = async () => {
      queryRef.current = 1;
      queryRef.name = state.keyword;
      await run(queryRef);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onSelectionChange = (ids: string[], selectedRows: LibraryListRecord[]) => {
      state.selectedIds = ids;
      let tmp = [] as Array<any>;
      data.value.forEach((o: any) => {
        if (ids.includes(o.id)) {
          tmp.push(o);
        }
      });
      state.selectedRows = tmp;
    };

    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "id"));
    };

    onMounted(async () => {
      if (props.materialCategoryId === undefined) {
        return;
      }
      await run(queryReq);
    });

    watch(
      () => props.materialCategoryId,
      async (newVal) => {
        queryReq.merge({ materialCategoryId: newVal, enable: true });
        if (newVal === undefined) {
          return;
        }
        await run(queryReq);
      },
      { immediate: true }
    );

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.id);
        state.selectedIds = ids;
      },
      { immediate: true }
    );
    const goCreate = (url)=>{
      emit('close','')
      router.push(url)
    }
    return {
      ...toRefs(state),
      loading,
      data,
      pagination,
      search,
      onTableChange,
      onSelectionChange,
      add,
      goCreate
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    margin-bottom: 10px;
  }
}
</style>
